module.exports = __webpack_public_path__ + "static/img/Planificaciones_3_pruébalo gratis@4x.4d7b120c.png";